import { curry } from 'lodash'
import yankBy from './yank-by'

function orderLastBy(iteratee, options) {
  const [last, rest] = yankBy(options, iteratee)
  return last ? [...rest, last] : rest
}

export default curry(orderLastBy)
